import createTakenError from 'scripts/domain/factories/error/create_taken_error';
import createUpdateAction from '../lib/create_update_action';
import RoutingGroup from 'models/routing_group';

export default class UpdateRoutingGroup extends createUpdateAction(RoutingGroup) {
  _getValidationErrors(attrs) {
    var modelErrors = RoutingGroup.getValidationErrors(attrs);

    var namingConflict = !!this.context.stores.routingGroups
      .findAll({ name: attrs.name })
      .filter(function(routingGroup) {
        return routingGroup.id !== attrs.id;
      }).length;

    var namingErrors = namingConflict ? [createTakenError('name', attrs.name)] : [];

    return modelErrors.concat(namingErrors);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/routing_groups/update_routing_group.js